module.exports = __webpack_public_path__ + "media/images/iconSocialMail__accent-ebd47c3e3096680070d8aff4b0a47a08.png";